const dateFormat = {
  DATE_TIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  DAY_FORMAT: "YYYY-MM-DD",
  DATE_FORMAT_FILTER_USER_LIST: "MM/DD/YYYY",
};
const timezone = "(UTC)";

export { dateFormat, timezone };
